module.exports = __webpack_public_path__ + "static/Keung-de2853044eafd954eeb8bee71d8b2b8a.png";